import template from './productos.html';
import { FormActions } from 'core/services/form';
import productosI18N from 'i18n/productos/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';

export let ProductosComponent = {
  templateUrl: template,
  selector: 'productos',
  bindings: {
    translations: '='
  },
  controller: ProductosCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(productosI18N).concat(commonsI18N).concat(commonI18N);

ProductosCtrl.$inject = [
  'BasicFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function ProductosCtrl(BasicFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['codigo', 'nombre', 'servicioPadre.nombre', 'categoria.nombre', 'categoria.clase.value'];
  var staticFilter = Filter.path('activo').eq(true);
  BasicFactory.setup('productos');

  const claseQuery = Filter.path('tipo.codigo').eq('clase_categoria_producto');
  const claseUrl = encodeURI('valores?filter=' + JSON.stringify(claseQuery));

  const estadoQuery = Filter.path('tipo.codigo').eq('estado_producto');
  const estadoUrl = encodeURI('valores?filter=' + JSON.stringify(estadoQuery));

  this.options = {
    staticFilter,
    resource: 'productos',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de productos'],
    factory: BasicFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'codigo', title: this.translations['Código'] },
      { data: 'nombre', title: this.translations['Nombre'] },
      {
        data: 'servicioPadre.nombre',
        title: this.translations['Padre'],
        render: function(data, type, row) {
          return row.servicioPadre ? row.servicioPadre.nombre : '<i>Sin Padre</i>';
        }
      },
      { data: 'categoria.nombre', title: this.translations['Nombre Categoría'] },
      {
        data: 'categoria.clase.value',
        title: this.translations['Clase'],
        type: 'combo',
        filterUrl: claseUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.categoria ? row.categoria.clase.name : '<i>No establecido</i>';
        }
      },
      { data: 'codigoBarra', title: this.translations['Código de barras'] },
      {
        data: 'estado.name',
        title: this.translations['Estado'],
        type: 'combo',
        filterUrl: estadoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.estado ? row.estado.name : '<i>No establecido</i>';
        }
      },
      { data: 'duracion', title: this.translations['Duración'] },
      { data: 'tipoImpuesto.nombre', title: this.translations['Tipo de impuesto'] },
      { data: 'familiaProducto.nombre', title: this.translations['Familia'] },
      {
        data: 'proveedor.nombre',
        title: this.translations['Proveedor'],
        render: function(data, type, row) {
          return row.proveedor ? row.proveedor.nombre : '<i>No establecido</i>';
        }
      },
      {
        data: 'adicional.nombre',
        title: this.translations['Adicional'],
        render: function(data, type, row) {
          return row.adicional ? row.adicional.nombre : '<i>No establecido</i>';
        }
      },
      {
        data: 'marca.nombre',
        title: this.translations['Marca'],
        render: function(data, type, row) {
          return row.marca ? row.marca.nombre : '<i>No establecido</i>';
        }
      },
      {
        data: 'precioDatatablesPayload.monto',
        title: this.translations['Precio'],
        renderWith: 'monedaRender',
        pathAttMoneda: 'precioDatatablesPayload.monedaValue'
      }
    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_productos'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_productos'),
    canUsoInsumo: canUsoInsumo.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Controlar uso de insumo'] + '" ng-show="options.canUsoInsumo(rowsData[<%= dataId %>])" ng-click="usosInsumo(<%= dataId %>)"> <span class="glyph-icon icon-check" style="top: -8px;"></span></button>',
        functionName: 'usosInsumo',
        functionDef: (itemId) => {
          this.$state.go('home.productos.uid.usos-insumo.list', { uid: itemId });
        }
      }
    ]
  };

  function canUsoInsumo(data) {
    return (data.controlStock === 'Sí') && AuthorizationService.hasPermission('index_usos_insumo');
  }


  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.gotoForm = gotoForm.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.reports.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de productos']
    };
    this.form();
  };

  function mapStateToThis(state) {

    this.handleStatus(state);
    return { form: state.form };
  }

  function handleStatus(state) {
    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }
    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }
  }

  function gotoForm() {
    this.$state.go('home.productos.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.productos.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('productos', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.productos.uid.view', { uid: itemId });
  }
}


// WEBPACK FOOTER //
// ./src/components/productos/list/productos.component.js